
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        classIcon: String
    }
})
